import { Injectable } from '@angular/core';
import { ResourceAction, ResourceParams, IResourceMethod } from '@ngx-resource/core';
import { RestClient } from './rest.client';
import { environment } from '../../environments/environment';
// Interfaces
import { Dashboard } from '../interfaces/IDashboard';
// Import RxJs required methods

@Injectable()
@ResourceParams({
    url: `${environment.url.api}`,
    pathPrefix: '/api/dashboard'
})
export class DashboardService extends RestClient {
    @ResourceAction({
        path: '/'
    })
    getDashboard: IResourceMethod<{}, Dashboard>;
}
